import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import HelpTooltipIcon from '../../../../components/HelpTooltipIcon'
import BasicWidget from '../../Stats/components/widgets/BasicWidget'
import { useCountersAnalyticsData } from '../../analytics/hooks/use-counters-analytics-data'

const FrequencyTimeWidget = () => {
  const { t } = useTranslation()
  const { hour2Rows, isLoading } = useCountersAnalyticsData()

  const { highestLabel, lowestLabel } = useMemo(() => {
    if (!hour2Rows.length) {
      return { highestLabel: '', lowestLabel: '' }
    }

    const values = hour2Rows.map((row) => row.value)
    const maxValue = Math.max(...values)
    const minValue = Math.min(...values)
    const highest = hour2Rows.find((row) => row.value === maxValue)
    const lowest = hour2Rows.find((row) => row.value === minValue)

    return {
      highestLabel: highest?.label
        ? t(`newAnalytics.hour2.${highest.label}`)
        : '',
      lowestLabel: lowest?.label ? t(`newAnalytics.hour2.${lowest.label}`) : '',
    }
  }, [hour2Rows, t])

  return (
    <BasicWidget
      title={highestLabel}
      subtitle={t('stats.highestFrequencyTime')}
      iconRight={<HelpTooltipIcon text={t('stats.tooltips.frequencyTime')} />}
      chipLabel={`${lowestLabel} ${t('stats.lowestFrequencyTime')}`}
      isLoading={isLoading || !hour2Rows.length}
    />
  )
}

export default FrequencyTimeWidget
